<template>
    <div v-if="(loading||(!noData&&ecConfig)||showErrors)&&(!startHiddenEquip||equipment)" :style="verticalOffset ? 'position:relative; top:'+verticalOffset+'px; z-index:999999;' : ''">
        <vue-echart v-if="!noData&&ecConfig" :white-mode="whiteMode" :config="!loading&&ecConfig" :height="height" :update-options="{notMerge:!enableMerge}" :transparent-mode="verticalOffset&&verticalOffset!==0"></vue-echart>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="showErrors&&!loading&&errors&&errors.length>0" class="pa-2">
            <v-alert v-for="error in errors"
                     :value="true"
                     style="padding: 6px;"
                     type="error"
            >
                {{error}}
            </v-alert>
        </div>
        <div v-if="showErrors&&!loading&&dataWarnings&&dataWarnings.length>0" class="pa-2">
            <v-alert v-for="dataWarning in dataWarnings"
                     :value="true"
                     style="padding: 6px;"
                     type="warning"
            >
                {{dataWarning.title}} <v-icon small class="ml-2 cursor-as-pointer" @click="dataWarning.showDetail=true">fa-info</v-icon>
                <v-dialog v-model="dataWarning.showDetail" max-width="600">
                    <v-card>
                        <v-card-title class="primary white--text title">
                            {{dataWarning.title}}
                        </v-card-title>
                        <v-card-text>
                              <pre>
                                  {{dataWarning.details}}
                              </pre>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dataWarning.showDetail=false">{{'Close'|translate}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-alert>
        </div>
        <div v-if="showErrors&&!loading&&missingSensors&&missingSensors.length>0" class="pa-2">
            <v-alert
                :value="true"
                style="padding: 6px;"
                type="warning"
            >
                {{'Missing sensors : '|translate}}
                <v-chip  v-for="missingSensor in missingSensors" >{{missingSensor}}</v-chip>
            </v-alert>
        </div>
    </div>
</template>

<script>
import VueEchart from "@/components/VueEchart";
import LoadingProgressBar from "../LoadingProgressBar";
import {callAPI} from '@/helper'
import * as echarts from 'echarts';
import 'echarts-gl';
import data3Processor from "../mixins/data3Processor";
import {mapGetters} from "vuex";

export default {
    props: {
        whiteMode: {type: Boolean, default: false},
        enableMerge:{type: Boolean, default: false},
        showErrors:{type: Boolean, default: false},
        parameters: {type: Object, default: null},
        settings: {type: Object, default: function(){return {}}},
        equipment: {type:String, default: null},
        noReload: {type: Boolean, default: false},
        startHiddenEquip: {type: Boolean, default: false},
        height: {type: Number, default: 300},
        timer: {type: Number, default: 5},
        verticalOffset: {type: Number, default: null},
        animationMode: {type: Boolean, default: false},
        dateRange: {type: Object, default: null},
        data3query: {
            type: Object, default:null
        },
        processorFunction:{type: String, default: null},
    },
    components: {VueEchart,LoadingProgressBar},
    mixins:[data3Processor],
    computed: {
        ...mapGetters([
            'chartColorways',
        ]),
        ecConfig(){
            if (!this.config){
                return null
            } else if (this.animationMode){
                return this.config[this.configIndex]
            } else {
                return this.config
            }
        }
    },
    name: 'CustomEcWidget',
    data: function () {
        return {
            interval:null,
            firstRender:true,
            noData:false,
            errors:[],
            dataWarnings:[],
            missingSensors:[],
            configIndex:0,
            reloadInc:0,
            config:null,
            loading:false,
            timeout:null,
        }
    },
    beforeDestroy: function(){
        clearInterval(this.interval)
    },
    watch: {
        dateRange () {
            if (this.data3query) {
                this.refresh()
            }
        },
        equipment () {
            if (this.data3query) {
                this.refresh()
            }
        },
        showErrors () {
            if (this.data3query) {
                this.refresh()
            }
        },
        parameters:{
            handler() {
                if(this.data3query){
                    this.refresh()
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted: function(){
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.getData,this.noReload ? 50 : 500);
        },
        incConfig() {
            if (this.configIndex < this.config.length - 1) {
                this.configIndex += 1;
            } else {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        async getData(){
            clearInterval(this.interval)
            if (this.firstRender||!this.noReload){
                this.loading=true
                this.config=null
            }
            this.noData=false
            this.errors=[]
            this.dataWarnings=[]
            this.missingSensors=[]
            let data = {}
            this.reloadInc=this.reloadInc+1
            let currentInc=this.reloadInc
            if (this.data3query) {
                let payloadArray = JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray = payloadArray.filter(x => x.filters && (x.filters.sensor_name || x.filters.equipment_name))
                for (let payload of payloadArray) {
                    payload.parameters=this.parameters
                    this.processDateRange(payload, this.dateRange)
                    if (!payload.filters.facility_name && this.$store.state.pointsListStore.pointsList.facility_name) {
                        payload.filters.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if(this.equipment){
                        this.processEquipment(payload, this.equipment)
                    }
                    if (payload.onOnly) {
                        if (!payload.pipeline) {
                            payload.pipeline = []
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let promises = payloadArray.map(payload => callAPI('data3/', payload))
                let results = await Promise.all(promises)
                if (this.showErrors){
                    this.missingSensors=this.findMissingSensors(payloadArray)
                }
                if (currentInc!==this.reloadInc){
                    return
                }
                let noData=true
                for (let result of results) {
                    if (result.data.timestamp&&result.data.timestamp.length>0){
                        noData=false
                    }
                }
                for (let result of results) {
                    if(result.data.error){
                        this.errors.push(result.data.error)
                        continue
                    }
                    if (!noData&&(!result.data.timestamp||result.data.timestamp.length===0)){
                        this.dataWarnings.push({title:"No data for query "+(results.indexOf(result)+1),details:JSON.stringify(payloadArray[results.indexOf(result)], null, 4),showDetail:false})
                    }
                    for (let seriesIndex in result.data) {
                        if (!data[seriesIndex]) {
                            data[seriesIndex] = result.data[seriesIndex]
                        }
                    }
                }
                if (noData){
                    this.dataWarnings.push({title:"No data for this chart",details:JSON.stringify(payloadArray, null, 4),showDetail:false})
                    this.loading=false
                    this.config=null
                    return
                }
            }
            if (this.processorFunction&&this.processorFunction!==""){
                let processData=eval(this.processorFunction)
                echarts.unifiedIsThemeDark=this.unifiedIsThemeDark
                this.config=processData(data,echarts,this.chartColorways,this.settings)
                try {
                    let processData=eval(this.processorFunction)
                    this.config=processData(data,echarts,this.chartColorways,this.settings)
                } catch (error) {
                    this.loading=false
                    this.config=null
                    return
                }
                if (this.animationMode&&this.config&&this.timer){
                    let me =this
                    me.interval=setInterval(function() { me.incConfig() }, this.timer*1000);
                }
            }
            this.loading=false
            this.firstRender=false
        }
    }
}

</script>

<style scoped>

</style>
